
import { VueMountable } from 'vue-mountable';

export default defineNuxtPlugin((nuxtApp) => { 
    // console.log('salut')
    nuxtApp.vueApp.use(VueMountable())
})